<template>
  <div>
    <div
      v-for="message in messages" :key="message.id"
      :class="$style.item"
    >
      <a
        :href="message.attachment.link"
        target="_blank"
        :class="$style.file"
        @click.stop
      >
        <div :class="$style.iconWrap">
          <BaseIcon name="file" :class="$style.icon" />
        </div>
        <div>
          <a
            @click.stop
            :href="message.attachment.link"
            target="_blank"
          >{{ message.attachment.name }}</a>
          <div :class="$style.size">({{ getSize(message.attachment.size) }})</div>
        </div>
      </a>
    </div>
    <infinite-loading
      :class="$style.infiniteLoading"
      @infinite="infiniteHandler"
    >
      <Spinner slot="spinner" />
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>

<script>
import { ATTACHMENT_CODE } from '@/models/Message'
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/Spinner'
import superbytes from 'superbytes'
import api from '@/api'

export default {
  name: 'profile-shared-files',
  components: {
    InfiniteLoading,
    Spinner
  },
  props: {
    chat: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      page: 1,
      messages: []
    }
  },
  methods: {
    fetch () {
      return api.chats.mediaAttachments(this.chat.id, {
        type: ATTACHMENT_CODE['file'],
        page: this.page
      })
    },
    async infiniteHandler ($state) {
      const { data } = await this.fetch()
      if (data.length) {
        this.messages = this.messages.concat(data)
        $state.loaded()
        this.page += 1
      } else {
        $state.complete()
      }
    },
    getSize (size) {
      return superbytes(size)
    }
  }
}
</script>

<style module lang="scss">
.item {
  padding: 10px 20px;
  &:not(:first-child) {
    border-top: 1px solid $border-color;
  }
}
.iconWrap {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($main-bg-colored, 0.2);
  margin-right: 8px;
  flex-shrink: 0;
  position: relative;
}
.icon {
  font-size: 20px;
  color: $text-colored;
}
.file {
  display: flex;
  align-items: center;
}
.size {
  color: $text-light;
  font-size: 12px;
}
.image {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.infiniteLoading {
  height: 50px;
  padding: 20px 0;
  margin: 0 auto;
  flex-basis: 100%;
}
</style>
